import { Alert, background, Box, Button, ButtonGroup, Checkbox, Container, Grid, GridItem, Heading, HStack, Image, Input, Link, Menu, MenuButton, MenuItem, MenuList, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, SimpleGrid, Slider, SliderFilledTrack, SliderThumb, SliderTrack, Spacer, Spinner, Stack, Text, useColorMode, useColorModePreference, useColorModeValue, useDisclosure, useToast, VStack } from "@chakra-ui/react";
import { ethers } from "ethers";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import * as constants from "../constants"
import { useParams } from "react-router-dom"
import abi from "../abis/werc20.json"
import erc20abi from "../abis/erc20.json"
import { ChevronDownIcon } from "@chakra-ui/icons";
import { providers } from "ethers/lib";
import Moralis from "moralis";
import { EvmChain } from "@moralisweb3/common-evm-utils";


const shorten = (add) => {
    return add.slice(0, 5) + "..." + add.slice(-4)
}

await Moralis.start({
    apiKey: 'rTO3ivS5kbrUYLADjiK07aprt07UIKh9lcdEy346azAzfSGi6zfYLBA4z9C1MuE4'
})

export default function Mint() {

    const provider = constants.n43114.Provider
    const signer = constants.n43114.Signer
    const contractAddress = '0x794fAEFa2199869DD3e5660Db5623c55e9bcF8db'
    const contract = useMemo(() => new ethers.Contract(contractAddress, abi, signer), [signer])
    const wavaxAddress = '0xB31f66AA3C1e785363F0875A1B74E27b85FD66c7'
    const wavax = useMemo(() => new ethers.Contract(wavaxAddress, abi, signer), [signer])
    const toast = useToast()
    const [address, setAddress] = useState("")
    const [balance, setBalance] = useState(0)
    const [NFTs, setNFTs] = useState()
    const [tokens, setTokens] = useState()
    const [selectedToken, setSelectedToken] = useState()
    const [allowance, setAllowance] = useState(0)
    const [decimals, setDecimals] = useState(18)
    const [amount, setAmount] = useState(1)
    const [loading, setLoading] = useState(false)
    const handleError = (err) => {
        toast({
            title: "Error",
            description: (err.reason || err.message),
            status: "error",
            duration: 9000,
            isClosable: true,
        })
        setLoading(false)
    }

    const connect = useCallback(async () => {
        try {
            await provider.request({
                method: "wallet_requestPermissions",
                params: [{
                    eth_accounts: {}
                }]
            }).then(() => provider.request({
                method: 'eth_requestAccounts'
            }))
        } catch (err) {
            console.log(err)
        }
        try {
            await provider.enable()

        } catch (err) {
            console.log(err)
        }
    }, [provider])





    useEffect(() => {
        constants.changeNetwork(43114)
        signer.getAddress().then(setAddress)
        if(selectedToken){
            const token = new ethers.Contract(selectedToken._token.contractAddress._value, erc20abi, signer)
            token.balanceOf(address).then(e=>setBalance(e.toString()))
            token.allowance(address, contractAddress).then((allowance) => {
                setAllowance(allowance.toString())
            })  
            token.decimals().then((decimals) => {
                setDecimals(decimals)
            })
        }

    }, [NFTs, address, connect, selectedToken, signer])

    useMemo(()=>{
        if (address) {
            fetch("https://deep-index.moralis.io/api/v2/" + address + "/nft?chain=0xa86a&token_addresses=0x794fAEFa2199869DD3e5660Db5623c55e9bcF8db", { method: "GET", headers: { accept: 'application/json', 'X-API-Key': "rTO3ivS5kbrUYLADjiK07aprt07UIKh9lcdEy346azAzfSGi6zfYLBA4z9C1MuE4" } }).then((nfts) => {
                nfts.json().then(e => {
                    setNFTs(e.result)
                })
            })
            Moralis.EvmApi.token.getWalletTokenBalances({
                address: address,
                chain: EvmChain.AVALANCHE,
                tokenAddresses: []
            }).then((tokens) => {
                setTokens(tokens.result)
                console.log(tokens.result)
            })

        }
    }, [address])


    const mint = async () => {
        setLoading(true)
        if(allowance.toString() < ethers.utils.parseUnits(amount.toString(), decimals.toString())){
            const t = new ethers.Contract(selectedToken._token.contractAddress._value, erc20abi, signer)
            const tx = await t.approve(contractAddress, ethers.utils.parseUnits(amount.toString(), decimals.toString())).catch(handleError)
            await tx.wait()
            setAllowance(ethers.utils.parseEther(amount.toString()))
        }
        const tx = await contract.mint(selectedToken._token.contractAddress._value  ,ethers.utils.parseUnits(amount.toString(),decimals.toString())).catch(handleError)
        await tx.wait()
        toast({
            title: "Success",
            description: `Minted ${amount} ${selectedToken._token.name}!`,
            status: "success",
            duration: 9000,
            isClosable: true,
        })
        setLoading(false)
    }



    const redeem = async (tokenId)=>{
        const tx = await contract.redeem(tokenId).catch(handleError)
        await tx.wait()
        toast({
            title: "Success",
            description: `Redeemed token!`,
            status: "success",
            duration: 9000,
            isClosable: true,
        })
    }

    return (
        <Container maxW="container.xl" centerContent p='50' gap={2}>
            <Heading>Wrap ERC20 tokens</Heading>
            <Button onClick={connect}>{address ? shorten(address) : 'Connect'}</Button>
            <Menu>
                <MenuButton as={Button} disabled={loading} rightIcon={<ChevronDownIcon />}>
                    {selectedToken? selectedToken._token.name: 'Select Token'}
                </MenuButton>
                <MenuList>
                    {tokens?.map((token, index)=>{
                        if(token._token.contractAddress._value !== wavaxAddress){
                            return(
                                <MenuItem onClick={()=>setSelectedToken(token)}>{token._token.name}</MenuItem>
                            )
                        }
                    }
                    )}
                </MenuList>
            </Menu>
            <Text>Balance: {ethers.utils.formatEther(balance)}</Text>
            <Text>Amount to wrap: </Text>
            <Input width={'400px'} placeholder="Amount" value={amount} onChange={(e) => setAmount(e.target.value)} />
            <Text>You are expected to sign two transactions, one for approval and one for minting.</Text>
            <Button disabled={loading} onClick={mint}>Mint</Button>
            <Heading>Unwrap</Heading>
            <Alert status="warning" width={'400px'}>There's a 5% tax when unwrapping</Alert>
            <SimpleGrid autoColumns={'auto'} minChildWidth={'100px'} >
            {NFTs?.map((nft, index)=>{
                const metadata = JSON.parse(nft.metadata)
                return(
                    <GridItem textAlign={'center'}>
                    <Image width={'200px'} src={metadata.image}/>
                    <Text>{metadata.name}</Text>
                    <Button onClick={()=> redeem(nft.token_id)}>Unwrap</Button>
                    </GridItem>
                )
            })}
            </SimpleGrid>
        </Container>

    );
}